import React from 'react'
import styled from 'styled-components'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { useApiContext } from '../Hooks/useApiContext';
import Button from '../Common/button'

const StyledLeavingSiteModal = styled(Modal)`
  .header {
    margin: 32px 32px 20px 32px;
    text-align: left;
  }

  .title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    letter-spacing: 0.15px;
    color: ${({ theme }) => theme.colors.black87};
  }

  .body {
    margin: 0 32px 20px 32px;
  }

  .body-text {
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.black87};
  }

  .buttons {
    display: flex;
    justify-content: flex-end;
    margin: 0 32px 36px 32px;

    .right-button {
      margin-left: 40px;
    }
  }
`

const LeavingSiteModal = ({ onHide, show, linkTo, uid }) => {;
  const { loan } = useApiContext()
  const isAuthenticated = Boolean(localStorage.getItem('ajs_user_traits'));
  const servicedAs = loan.data?.data?.loan?.loanData?.legalEntity?.legalEntity[0]?.servicer[0]?.servicedAs;
  return (
    <StyledLeavingSiteModal
      onHide={onHide}
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div className="header">
        <h6 className="title">Leaving site</h6>
      </div>
      <div className="body">
        <p className="body-text">
          You are now leaving {isAuthenticated ? servicedAs + '\'s' : 'the reversedepartment.com'} website and
          will be redirected to an external site. Please note that we
          are not responsible for the content, privacy policies, or
          practices of the service provider or their website. Click OK
          to continue.
        </p>
      </div>
      <div className="buttons">
        <Button
          linkTo="#"
          onClick={onHide}
          textButton
          text="STAY"
          UID={(uid && uid!=='leave_site_modal')?`${uid}_stay`:uid}
        />
        <Button
          className="right-button"
          onClick={() => {
            onHide()
            window.open(linkTo, '_blank')
          }}
          textButton
          text="OK"
          UID={(uid && uid!=='leave_site_modal')?`${uid}_read_more`:uid}
        />
      </div>
    </StyledLeavingSiteModal>
  )
}

LeavingSiteModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
}

export default LeavingSiteModal
